import React, { useState, useCallback, useMemo } from "react";
import Tabs from "../../../../../Tabs";
import Preset from "../Preset";
import ImageBrowser from "../../../ToolbarMediaBrowser/ImageBrowser";
import ImageCropper from "../../../../../ImageCropper";
import { Stack, CircularProgress } from "@mui/material";
import TextView from "../../../../../TextView";
import CropIcon from "@mui/icons-material/Crop";
import styled from "styled-components";
import UploadMedia from "../../../UploadMedia";
import UploadedImage from "../../../../Main/PortraitTab/UploadedImage";
import EmbedURL from "../../../EmbedURL";
import RecentMedia from "../../../RecentMedia";
import FeatureEligibility from "../../../../../FeatureEligibility";
import { FEATURES } from "../../../../../../constants/features";
import { useIfUserEligible } from "../../../../../../hooks/useIfUserEligible";

export const CropStack = styled(Stack)`
  background-color: rgba(156, 39, 176, 0.1);
  border-radius: 2px;
  padding: 1rem;
  margin-top: 2rem;
  cursor: pointer;
  cursor: ${(props) => (props.enable ? "pointer" : "not-allowed")};

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => props.opacity || 0.5};
`;

function ImageView({
  handleSelectWallpaper,
  bgWallpaper,
  isPattern,
  currentBg,
  handleSelectBackgroundResizeMode,
  resizeMode,
  handleEditImage,
  handleRemoveImage,
  showPreview = true,
  showEmbedURLDisclaimer = false,
}) {
  const categories = useMemo(
    () => ["Preset", "Upload", "URL", "Browse", "Recent"],
    []
  );
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [cropperVisible, setCropperVisible] = useState(false);

  const {
    isEligible,
    subscription,
    isCheckingEligibility,
    requiredSubscription,
  } = useIfUserEligible(FEATURES.WHEEL_WALLPAPER_IMAGE);

  const handleCategoryChange = useCallback((event, newValue) => {
    setSelectedCategory(newValue);
  }, []);

  const options = [
    { label: "Contain", value: 1 },
    { label: "Cover", value: 2 },
  ];

  const [selectedOption, setSelectedOption] = useState(resizeMode);
  const [open, setOpen] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    handleSelectBackgroundResizeMode(event.target.value);
  };

  if (isCheckingEligibility) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", padding: "20px" }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (!isEligible) {
    return (
      <FeatureEligibility
        subscription={subscription}
        requiredSubscription={requiredSubscription}
      />
    );
  }

  return (
    <div>
      {showPreview
        ? bgWallpaper &&
          !bgWallpaper.includes("linear") &&
          ["Upload", "Browse", "URL", "Preset", "Recent"].includes(
            selectedCategory
          ) && (
            <UploadedImage
              handleRemoveImage={handleRemoveImage}
              image={bgWallpaper?.src || bgWallpaper}
              setOpen={setOpen}
            />
          )
        : null}

      <Tabs
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
        color={"#81459B"}
        indicatorColor="#C283DA"
      />

      {selectedCategory === "Preset" ? (
        <Preset
          currentBg={currentBg}
          handleSelectWallpaper={handleSelectWallpaper}
          bgWallpaper={bgWallpaper}
        />
      ) : selectedCategory === "Upload" ? (
        <UploadMedia
          type="image"
          handleMedia={(val) => handleSelectWallpaper(val?.src)}
        />
      ) : selectedCategory === "Browse" ? (
        <ImageBrowser
          onConfirm={(image) => handleSelectWallpaper(image?.src)}
        />
      ) : selectedCategory === "URL" ? (
        <EmbedURL
          defaultValue={""}
          type={"image"}
          onConfirm={(value) => handleEditImage(value?.src)}
          showDisclaimer={showEmbedURLDisclaimer}
        />
      ) : selectedCategory == "Recent" ? (
        <RecentMedia
          type={"image"}
          onClickMedia={(value) => handleSelectWallpaper(value.src)}
        />
      ) : null}
    </div>
  );
}

export default ImageView;
